import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { InboundE164Read } from '@ragu-components/ord-types';

const InboundE164sList = React.lazy(async () => import('./InboundE164sList'));

export const inboundE164Resource: OrdResourceProps = {
  key: Resources.inbound_e164s,
  name: Resources.inbound_e164s,
  list: <InboundE164sList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: InboundE164Read) => record.e164_match,
};
